import { render, staticRenderFns } from "./coupon-home.vue?vue&type=template&id=f24583ec&scoped=true&"
import script from "./coupon-home.vue?vue&type=script&lang=js&"
export * from "./coupon-home.vue?vue&type=script&lang=js&"
import style0 from "./coupon-home.vue?vue&type=style&index=0&id=f24583ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24583ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
